import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import BanDoChatLuongDatApi from '../../api/BanDoChatLuongDatApi';
import LopMauApi from '../../api/LopMauApi';

export const ModalEditThongTin = (props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        props.closeThongTin();
        setShow(false)
    };
    const { register, handleSubmit, reset } = useForm();
    const [selectedOption, setSelectedOption] = useState();
    const [listLopMau, setLopMau] = useState([]);
    const [gid, setGid] = useState('');
    useEffect(() => {
        loadLopMau();
    }, []);

    const saveData = (data) => {
        if (selectedOption) {
            data.dvdd = selectedOption.value;
        }
        data.gid = gid;
        data.geometry = props.thongTin.geometry;
        if (props.themMoi) {
            BanDoChatLuongDatApi.addThongTin(data).then(() => {
                setShow(false);
                props.saveSuccess();
            })
        }
        else {
            BanDoChatLuongDatApi.updateThongTin(data).then(() => {
                setShow(false);
                props.saveSuccess();
            })
        }
    }

    const onChangeMau = (e) => {
        setSelectedOption(e);
    }

    function loadLopMau() {
        LopMauApi.getLopBanDo().then((response) => {
            let list = [];
            list.push({ value: '', label: 'Chọn màu' });
            response.forEach(item => {
                if(item.Type == 3){
                    list.push({ value: item.MaMau, label: item.Ten });
                }
            })
            setLopMau(list);
        })
    }

    useEffect(() => {
        if (props.showEdit === true) {
            setGid(props.thongTin.gid);
            reset({
                caytrong: props.thongTin.caytrong,
                chisokhoha: props.thongTin.chisokhoha,
                dalan: props.thongTin.dalan,
                dhtd: props.thongTin.dhtd,
                dt_bs: props.thongTin.dt_bs,
                dungtrong: props.thongTin.dungtrong,
                dungtrong_: props.thongTin.dungtrong_,
                dvdd: props.thongTin.dvdd,
                g: props.thongTin.g,
                huyen: props.thongTin.huyen,
                khohan_dt: props.thongTin.khohan_dt,
                luongmua_d: props.thongTin.luongmua_d,
                madat: props.thongTin.madat,
                mau_anhhuo: props.thongTin.mau_anhhuo,
                ngapung_dt: props.thongTin.ngapung_dt,
                nhietdo: props.thongTin.nhietdo,
                pc_cec: props.thongTin.pc_cec,
                pc_chisokh: props.thongTin.pc_chisokh,
                pc_dd: props.thongTin.pc_dd,
                pc_dp: props.thongTin.pc_dp,
                pc_k: props.thongTin.pc_k,
                pc_n: props.thongTin.pc_n,
                pc_om: props.thongTin.pc_om,
                pc_p: props.thongTin.pc_p,
                pc_ph: props.thongTin.pc_ph,
                phanvung: props.thongTin.phanvung,
                sl: props.thongTin.sl,
                sothangkho: props.thongTin.sothangkho,
                tangday: props.thongTin.tangday,
                tenpd: props.thongTin.tenpd,
                tieu_dt: props.thongTin.tieu_dt,
                tinh: props.thongTin.tinh,
                tpcg: props.thongTin.tpcg,
                tton_dt: props.thongTin.tton_dt,
                tuoi_dt: props.thongTin.tuoi_dt,
                xa: props.thongTin.xa
            }, [reset])
            setShow(true);
            var index = listLopMau.findIndex(x => x.value == props.thongTin.dvdd);
            setSelectedOption(listLopMau[index]);
        }

    }, [props.showEdit]);



    return (
        <div className="card shadow mb-1">

            <Modal show={show} onHide={handleClose} animation={false} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Thông tin</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="user" onSubmit={handleSubmit(saveData)}>
                        <input name="Id" hidden={true} ref={register}></input>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Huyện</label>
                            <div className="col-sm-2">
                                <input name="huyen" type="text" className="form-control" placeholder="Tên huyện" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Xã</label>
                            <div className="col-sm-2">
                                <input name="xa" type="text" className="form-control" placeholder="Tên xã" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân vùng</label>
                            <div className="col-sm-2">
                                <input name="phanvung" type="text" className="form-control" placeholder="Phân vùng" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Loại đất</label>
                            <div className="col-sm-2">
                                <input name="g" type="text" className="form-control" placeholder="Loại đất" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Địa hình tương đồi</label>
                            <div className="col-sm-2">
                                <input name="dhtd" type="text" className="form-control" placeholder="Địa hình tương đối" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Địa hinh</label>
                            <div className="col-sm-2">
                                <input name="sl" type="text" className="form-control" placeholder="Địa hinh" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Tầng dày</label>
                            <div className="col-sm-2">
                                <input name="tangday" type="text" className="form-control" placeholder="Tầng dày" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">T.Phần cơ giới</label>
                            <div className="col-sm-2">
                                <input name="tpcg" type="text" className="form-control" placeholder="Thành phần cơ giới" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Mức độ đá lẫn</label>
                            <div className="col-sm-2">
                                <input name="dalan" type="text" className="form-control" placeholder="Mức độ đá lẫn" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Dung trọng</label>
                            <div className="col-sm-2">
                                <input name="dungtrong" type="text" className="form-control" placeholder="Dung trọng" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp PH</label>
                            <div className="col-sm-2">
                                <input name="pc_ph" type="text" className="form-control" placeholder="Phân cấp PH" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp CEC</label>
                            <div className="col-sm-2">
                                <input name="pc_cec" type="text" className="form-control" placeholder="Phân cấp CEC" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Phân cấp dinh dưỡng</label>
                            <div className="col-sm-2">
                                <input name="pc_dd" type="text" className="form-control" placeholder="Dinh dưỡng" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp Nito</label>
                            <div className="col-sm-2">
                                <input name="pc_n" type="text" className="form-control" placeholder="Nito" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp Phốt pho</label>
                            <div className="col-sm-2">
                                <input name="pc_p" type="text" className="form-control" placeholder="Phốt pho" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Phân cấp kali</label>
                            <div className="col-sm-2">
                                <input name="pc_k" type="text" className="form-control" placeholder="Kali" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp hữu cơ</label>
                            <div className="col-sm-2">
                                <input name="pc_om" type="text" className="form-control" placeholder="Hữu cơ" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp độ phì</label>
                            <div className="col-sm-2">
                                <input name="pc_dp" type="text" className="form-control" placeholder="Độ phì" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Lượng mưa</label>
                            <div className="col-sm-2">
                                <input name="luongmua_d" type="text" className="form-control" placeholder="Lượng mưa" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Tổng tích ôn</label>
                            <div className="col-sm-2">
                                <input name="tton_dt" type="text" className="form-control" placeholder="Tổng tích ôn" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Mức độ khô hạn</label>
                            <div className="col-sm-2">
                                <input name="khohan_dt" type="text" className="form-control" placeholder="Khô hạn" ref={register} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Nhiệt độ</label>
                            <div className="col-sm-2">
                                <input name="nhietdo" type="text" className="form-control" placeholder="Nhiệt độ" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Chỉ số khô hạn</label>
                            <div className="col-sm-2">
                                <input name="chisokhoha" type="text" className="form-control" placeholder="Chỉ số khô hạn" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Phân cấp khô hạn</label>
                            <div className="col-sm-2">
                                <input name="pc_chisokh" type="text" className="form-control" placeholder="Phân cấp khô hạn" ref={register} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Số tháng khô hạn</label>
                            <div className="col-sm-2">
                                <input name="sothangkho" type="text" className="form-control" placeholder="Số tháng khô hạn" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Chế độ tưới</label>
                            <div className="col-sm-2">
                                <input name="tuoi_dt" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Mẫu ảnh hưởng</label>
                            <div className="col-sm-2">
                                <input name="mau_anhhuo" type="text" className="form-control" placeholder="Mẫu ảnh hưởng" ref={register} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Mã đất</label>
                            <div className="col-sm-2">
                                <input name="madat" type="text" className="form-control" placeholder="Mã đất" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Cây trồng</label>
                            <div className="col-sm-2">
                                <input name="caytrong" type="text" className="form-control" placeholder="Cây trồng" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Ngập úng</label>
                            <div className="col-sm-2">
                                <input name="ngapung_dt" type="text" className="form-control" placeholder="Ngập úng" ref={register} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Tên phẫu diện</label>
                            <div className="col-sm-2">
                                <input name="tenpd" type="text" className="form-control" placeholder="Chế độ tưới" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Chế độ tiêu</label>
                            <div className="col-sm-2">
                                <input name="tieu_dt" type="text" className="form-control" placeholder="Chế độ tiêu" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Diện tích</label>
                            <div className="col-sm-2">
                                <input name="dt_bs" type="text" className="form-control" placeholder="Diện tích" ref={register} />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Dung trọng</label>
                            <div className="col-sm-4">
                                <input name="dungtrong_" type="text" className="form-control" placeholder="Dung trọng" ref={register} />
                            </div>
                            <label className="col-sm-2 col-form-label">Màu sắc</label>
                            <div className="col-sm-4">
                                <Select
                                    className="select"
                                    name="Type"
                                    placeholder="Chọn màu"
                                    defaultValue={selectedOption}
                                    onChange={onChangeMau}
                                    options={listLopMau}
                                    theme={theme => ({
                                        ...theme,
                                        borderRadius: 0,
                                        height: 30,
                                        spacing: {
                                            controlHeight: 30,
                                            menuGutter: 1,
                                            baseUnit: 2,
                                        }
                                    })}
                                />
                            </div>
                        </div>


                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" size="sm" onClick={handleSubmit(saveData)}>
                        Lưu</Button>
                    <Button variant="danger" size="sm" onClick={handleClose}>
                        Hủy</Button>
                </Modal.Footer>
            </Modal>

        </div>

    )
}
